/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_ALLERGIES, GET_ALLERGIES, REQUEST_HIDDEN_ALLERGIES, GET_HIDDEN_ALLERGIES } from 'src/actions/allergyActions';

const initialState = {
  allergies: [],
  hiddenAllergies: [],
  isFetching: false,
  message: ''
};

const allergyReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ALLERGIES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_ALLERGIES: {
      const { allergies, message } = action.payload;

      return produce(state, (draft) => {
        draft.allergies = allergies;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    case REQUEST_HIDDEN_ALLERGIES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_HIDDEN_ALLERGIES: {
      const { hiddenAllergies, message } = action.payload;

      return produce(state, (draft) => {
        draft.hiddenAllergies = [...hiddenAllergies].sort((a, b) => a.name.localeCompare(b.name, 'is'));
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default allergyReducer;
